import { inject, Injectable } from '@angular/core';

import { Observable, throttleTime } from 'rxjs';
import { map } from 'rxjs/operators';

import { AUTH_TOKEN, COMPANY_ID, ENVIRONMENT } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';

import { EventStreamService } from './offer-content-generator-stream.service';
import {
  OfferContentGeneratorRequest,
  OfferContentGeneratorResponse,
} from './offer-content-generator.types';

@Injectable({
  providedIn: 'root',
})
export class OfferContentGeneratorHttpService {
  public companyId = inject(COMPANY_ID);
  public token = inject(AUTH_TOKEN);
  public env: any = inject(ENVIRONMENT);
  public httpApi = inject(HttpApiService);

  constructor(private eventStreamService: EventStreamService) {}

  public fetchOne$(body: OfferContentGeneratorRequest): Observable<OfferContentGeneratorResponse> {
    return this.httpApi
      .post<string>(this.buildUrl(), null, body, {
        skipURLBuild: true,
        responseType: 'text',
      })
      .pipe(map(generatedContent => ({ content: generatedContent })));
  }

  public fetchOneByChunk$(body: OfferContentGeneratorRequest): Observable<any> {
    return this.eventStreamService
      .send<string>('POST', this.buildUrl(), { ...body, stream: body.stream })
      .pipe(throttleTime(250, undefined, { leading: true, trailing: true }));
  }

  private buildUrl(): string {
    const base = this.env.integrations.integrationsUrl;
    return `${base}/api/ai/c/${this.companyId}/offers/description`;
  }
}
